import { get } from 'lodash';
import { FormOption } from '../../../../../../../../types/Form';
import useAnswerForQuestion from '../../../../../hooks/useAnswerForQuestion';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';

const useAnswerOptions = (
  targetQuestion: FlowsQuestion,
  field?: string,
): FormOption[] => {
  const getAnswerForQuestion = useAnswerForQuestion();
  const answer: ArrayAnswer[] =
    (getAnswerForQuestion(targetQuestion.id)?.answer as
      | ArrayAnswer[]
      | undefined) || [];

  const { object_string_format } = targetQuestion?.rules || {};

  return answer.map((item, arrayIndex) => ({
    // If field is defined we should pick that field as the option value
    value: field ? item[field] : arrayIndex.toString(),
    label: getArrayAnswer(item, object_string_format!) || '',
  }));
};

type ArrayAnswer = string | number | Record<string, string>;

const getArrayAnswer = (
  arrayItem: ArrayAnswer,
  objectStringFormat: string,
): string => {
  if (typeof arrayItem === 'object') {
    const fields = objectStringFormat
      .match(new RegExp(/{{1,2}[a-z0-9_.]+}{1,2}/, 'gi'))
      ?.map((regex) => regex.replace(/[{}]+/g, ''));

    const dataFromAnswer: Record<string, string> = {};
    fields?.forEach((field) => {
      dataFromAnswer[field] = get(arrayItem, field);
    });

    let interpolatedObjectStringFormat = objectStringFormat;

    Object.entries(dataFromAnswer).forEach(([field, answer]) => {
      interpolatedObjectStringFormat = interpolatedObjectStringFormat.replace(
        new RegExp(`{{1,2}${field}}{1,2}`, 'g'),
        answer,
      );
    });

    return interpolatedObjectStringFormat;
  }

  if (typeof arrayItem === 'number') {
    return arrayItem.toString();
  }

  return arrayItem;
};

export default useAnswerOptions;
